<mat-card class="mat-elevation-z2 day-card">
  <mat-card-header>
    <mat-card-title>{{header}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-pollenflug-belastungsstufe [belastungsstufe]="belastungsstufe">
    </app-pollenflug-belastungsstufe>
    <app-pollenflug-tendenz [tendenz]="tendenz">
    </app-pollenflug-tendenz>
  </mat-card-content>
</mat-card>
